import UnAuthorizedPage from "./UnAuthorizedPage";

export default UnAuthorizedPage